// UI strings — every section title, lead, label, and CTA text on the site.
// Lives in JSON so non-devs / scripts / n8n / Claude can edit copy without
// touching components.
import data from './data/ui-strings.json';

import type { SocialEmbedCopy } from '@ui/sections/SocialEmbed';

export const uiStrings = data;

// Per-section convenience exports for ergonomic imports in routes.
export const projectsCopy     = data.projects;
export const talksCopy        = data.talks;
export const podcastsCopy     = data.podcasts;
export const writingCopy      = data.writing;
export const publicationsCopy = data.publications;
export const experienceCopy   = data.experience;
export const contactCopy      = data.contact;
export const contactCtaCopy   = data.contactCta;
// LinkedIn highlights in JSON come back as `string[][]`; the component expects
// `[string, string][]`. Cast once here so consumers stay typed.
export const socialEmbedCopy: SocialEmbedCopy = {
  ...data.socialEmbed,
  linkedinHighlights: data.socialEmbed.linkedinHighlights.map(
    (pair) => [pair[0] ?? '', pair[1] ?? ''] as readonly [string, string]
  ),
};
export const notFoundCopy     = data.notFound;
export const videosCopy       = data.videos;
